import { createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "custom-modal-overlay" }, null, -1)
const _hoisted_3 = { class: "custom-modal" }
const _hoisted_4 = { class: "custom-modal-dialog" }
const _hoisted_5 = { class: "custom-modal-content text-center" }
const _hoisted_6 = { class: "msg-header bg-warning text-white position-relative" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "icon text-white mt-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "2em",
    height: "2em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-triangle-fill",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.964 0L.165 13.233c-.457.778.091 1.767.982 1.767h13.706c.89 0 1.438-.99.982-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1-2.002 0 1 1 0 0 1 2.002 0z" })
  ])
], -1)
const _hoisted_9 = { class: "msg-body" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.ui.isActive.customModal)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (!_ctx.hideCloseButton)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "close position-absolute top-0 end-0 p-3 text-white",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args))),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args)), ["esc"])),
                      "aria-label": "Close"
                    }, [
                      _hoisted_7
                    ], 32))
                  : _createCommentVNode("", true),
                _hoisted_8
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("h3", null, _toDisplayString(_ctx.props.title ? _ctx.props.title : _ctx.$t("successful")), 1),
                (_ctx.titleMessage)
                  ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.titleMessage)), 1))
                  : _createCommentVNode("", true),
                (_ctx.subTitleMessage)
                  ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.subTitleMessage)), 1))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}